import { useQuery } from "@tanstack/react-query";
import { useRouter } from "next/router";
import {
  AgentDetails,
  AgentSelect,
  CommonAPI,
  SessionDetails,
  SessionLink,
} from "@bagel-web/common";
import { CopyValue, HeaderDetail, Inspector } from "@bagel-web/components";
import { sessionQueries } from "../queries";

const EventStreamHeaderDetail = ({
  sessionId,
  agentId,
  commonAPI,
}: {
  sessionId: string;
  agentId: string;
  commonAPI: CommonAPI;
}) => {
  const { isPending, data: session } = useQuery({
    queryKey: sessionQueries.get(sessionId),
    queryFn: () => commonAPI.fetchSession(sessionId),
  });

  const router = useRouter();

  return (
    <HeaderDetail>
      <HeaderDetail.Field label="Session ID">
        <Inspector
          View={SessionDetails}
          viewProps={{ session: session || null }}
          showLoading={isPending}
        >
          <CopyValue>{sessionId}</CopyValue>
        </Inspector>
      </HeaderDetail.Field>
      {session?.parent_session_id && (
        <HeaderDetail.Field
          label={
            <>
              <i className="bi-diagram-3-fill me-2" />
              Parent Session ID
            </>
          }
        >
          <SessionLink
            sessionId={session.parent_session_id}
            commonAPI={commonAPI}
          />
        </HeaderDetail.Field>
      )}
      <HeaderDetail.Field label="Agent">
        <div className="d-flex align-items-center">
          {(session?.agents?.length || 0) > 1 && (
            <AgentSelect
              value={agentId}
              agents={session?.agents || []}
              isLoading={isPending}
              onChangeValue={(aId) => {
                router.push(`/sessions/${sessionId}/agent/${aId}/event-stream`);
              }}
            />
          )}
          <Inspector
            View={AgentDetails}
            viewProps={{
              agent:
                session?.agents?.find((agent) => agent.id === agentId) || null,
            }}
            showLoading={!session}
          >
            <div className="d-flex align-items-center">
              {session?.agents?.length === 1 && <code>{agentId}</code>}
              <CopyValue value={agentId} />
            </div>
          </Inspector>
        </div>
      </HeaderDetail.Field>
    </HeaderDetail>
  );
};

export default EventStreamHeaderDetail;
